module.exports = __webpack_public_path__ + "img/apple-cider.a74e3fdd.jpg";